import React, { useState} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
	root: {
		"& .MuiTextField-root": {
			width: "100%",
		},
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
}));

export default function AddSupplierModal(props) {
	const classes = useStyles();
	const [open, setOpen] = useState(false);
	const {itemid, deleteItem} = props;

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleDelete = () => {
		deleteItem(itemid);
		setOpen(false);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
	};

	
	


	return (
		<div>
		<Button
        	variant="contained"
			color="primary"
        	startIcon={<DeleteIcon style={{color:"#fff"}}/>}
			style={{backgroundColor: "#E70000", color:"#fff"}}
        	onClick={handleOpen}>
				Delete
	     </Button>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={open}>
					<div className={classes.paper}>
						<h4 style={{marginBottom : "35px"}}id="transition-modal-title">Confirm Item Delete</h4>
						<form onSubmit={handleSubmit} className={classes.root}>
							<Grid container spacing={3}>
								<Grid item xs={8}>
									<p>Are you sure you want to remove this item?</p>
								</Grid>
							</Grid>
							<div className={classes.button}>
								<Button type="submit" 
									variant="contained" 
									color="primary"
									onClick={handleDelete}
								>
									Yes
								</Button>
								<Button
									variant="contained"
									onClick={handleClose}
									className={classes.buttonMarginRight}
								>
									No
								</Button>
							</div>
						</form>
					</div>
				</Fade>
			</Modal>
		</div>
	);
}
